
import { useSelector, useDispatch } from 'react-redux'
import { TopHeaderSettings, CenterSettingsContainer } from './settings.styled';
import { setViewResetItemModal } from 'features/settings/settingSlice';
import ResetSettingsItemModal from './accountInformation/ResetSettingsItemModal';
import { SettingsInputContainer, SettingsSubmitButton, SettingsBody } from './settings.styled';
import { useTranslation } from 'react-i18next';

function UpdateEmail(props) {
  const { t } = useTranslation('settings')

  const dispatch = useDispatch()
  const { profile } = useSelector((state) => state.profile)
  const { viewResetItemModal, isResetEmailSuccess, newEmail } = useSelector((state) => state.settings)

  // once the user has been verified, we can then send the html form from backend




  return (
    <CenterSettingsContainer>
      <TopHeaderSettings>{t('accountEdit.updateEmail')}</TopHeaderSettings>

      <SettingsBody>
        <SettingsInputContainer> 
          <input
            onFocus={() => dispatch(setViewResetItemModal(true))}
            value={ isResetEmailSuccess ? newEmail : profile.email} 
            name='email' 
            placeholder={ isResetEmailSuccess ? newEmail : profile.email} 
            disabled={viewResetItemModal ? true : false}
          />
          <SettingsSubmitButton 
            onClick={() => dispatch(setViewResetItemModal(true))}
          >
            {t('accountEdit.update')}
          </SettingsSubmitButton>
        </SettingsInputContainer>

      </SettingsBody>

      { viewResetItemModal && ( <ResetSettingsItemModal item={"Email"} /> ) }

    </CenterSettingsContainer>
  )
}

export default UpdateEmail
